import React from "react";
import Modal from "../../../../../shared-components/css-modules/toyota/organisms/Modal";
import type { ModalViewType } from "../../../../../../../common-deprecated/types/CommonTypes";
import type { ContentModalType } from "../../../../utils/modalConstants";
import Text from "../../../../../shared-components/css-modules/toyota/atoms/Text";
import styles from "./ContentModal.module.scss";
import SanitizedRenderer from "../../../../../../../common-deprecated/components/SanitizedRenderer";
import { sanitize } from "../../../../../../../common-deprecated/utils/sanitizer";

const ContentModal = (props: ModalViewType<ContentModalType>): JSX.Element | null => {
    const { show, close, modalSettings } = props;
    const { title, content } = modalSettings;

    return (
        <Modal open={show} onRequestClose={close} variant="content-height">
            {title && (
                <Text tag="h2" variant="header-regular">
                    {title}
                </Text>
            )}

            <div className={styles.content}>
                <SanitizedRenderer html={sanitize(content)} />
            </div>
        </Modal>
    );
};

export default ContentModal;
